import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import { Sector, sectorApi } from "@/api/misc";

export interface SectorState {
  sectors: Sector[];
}

const sectorModule: Module<SectorState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      sectors: [] as Sector[],
    } as SectorState),
  mutations: {
    setSectors(state: SectorState, sectors: Sector[]): void {
      state.sectors = sectors;
    },
  },
  actions: {
    async listAll(
      context: ActionContext<SectorState, RootState>
    ): Promise<void> {
      if (!context.state.sectors || context.state.sectors.length === 0) {
        context.commit("setSectors", await sectorApi.listSectors());
      }
    },
    async addSector(
      context: ActionContext<SectorState, RootState>,
      sector: Sector
    ): Promise<void> {
      await sectorApi.addSector(sector);
      context.commit("setSectors", await sectorApi.listSectors());
    },
    async editSector(
      context: ActionContext<SectorState, RootState>,
      sector: Sector
    ): Promise<void> {
      if (sector.id) {
        await sectorApi.editSector(sector);
        context.commit("setSectors", await sectorApi.listSectors());
      }
    },
    async removeSector(
      context: ActionContext<SectorState, RootState>,
      sector: Sector
    ): Promise<void> {
      if (sector.id) {
        await sectorApi.deleteSector(sector);
        context.commit("setSectors", await sectorApi.listSectors());
      }
    },
  },
};

export default sectorModule;
